<template>
<div>
  <el-dialog
    v-model="dialogFormVisible"
    :title="!isEdit ? '添加外部人员' : '编辑外部人员'"
    width="400px"
    destroy-on-close
    :close-on-click-modal="false"
    center
  >
    <el-form v-loading="loading" :model="form" label-width="110px" ref="RefForms" :rules="rules" class="add-or-edit-without-persons-forms">
      <el-form-item label="所属项目" prop="siteIds">
        <el-select v-model="form.siteIds" filterable placeholder="请选择所属项目" multiple>
          <el-option :label=item.label :value=item.value v-for="(item, i) in projectList" :key="i" />
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" autocomplete="off" placeholder="请输入客户名称" />
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" autocomplete="off" placeholder="请输入邮箱" />
      </el-form-item>
      <el-form-item label="客户联系电话" prop="telephone">
        <el-input v-model="form.telephone" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off" placeholder="请输入客户联系电话" />
      </el-form-item>
      <el-form-item label="其他联系方式">
        <el-input v-model="form.otherContactInfo" autocomplete="off" placeholder="请输入其他联系方式" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" v-if="!isEdit" @click="AddWithout('RefForms')">确定并发送链接</el-button>
        <el-button type="primary" v-else @click="EditWithout('RefForms')">编辑</el-button>
      </span>
    </template>
  </el-dialog>
</div>
</template>
<script>
import { PostLabelAllGuest, PutLabelAllGuest } from '@/api/label'
import { deepCopy } from '@/utils/utils'
export default {
  props: {
    show: Boolean,
    editObj: Object,
    projectList: Array,
  },
  name: 'AddOrEditWithoutPersons',
  data () {
    const checkEmail = (rule, value, callback) => {
      const regEmail = /^([a-zA-Z0-9]+[_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!regEmail.test(value)) {
        callback(new Error('email格式不正确'))
      } else {
        callback()
      }
    }
    return {
      form: {
        siteIds: [],
        name: null,
        email: null,
        telephone: null,
        otherContactInfo: null,
      },
      rules: {
        siteIds: [
          { required: true, message: '请至少选择一个所属项目', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入客户姓名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入客户邮箱', trigger: 'blur' },
          { required: true, validator: checkEmail, trigger: 'blur' },
        ],
        telephone: [
          { required: true, message: '请输入客户电话', trigger: 'blur' }
        ],
      },
      loading: false,
      uuid: undefined,
    }
  },
  emits: ['update:show', 'update'],
  computed: {
    dialogFormVisible: {
      get () {
        return this.show
      },
      set (v) {
        this.$emit('update:show', v)
      }
    },
    isEdit () {
      return this.editObj !== null
    },
  },
  methods: {
    async AddWithout (RefForms) {
      // 添加外部人员
      await this.$refs[RefForms].validate()
      this.loading = true
      const obj = deepCopy(this.form)
      obj.siteIds = obj.siteIds.join(',')
      try {
        await PostLabelAllGuest(obj)
        this.$emit('update')
        this.$message({
          type: 'success',
          message: '添加外部人员成功'
        })
        this.dialogFormVisible = false
      } catch (e) {
        this.$message({
          type: 'error',
          message: e.errmsg
        })
      } finally {
        this.loading = false
      }
    },
    async EditWithout (RefForms) {
      // 编辑
      await this.$refs[RefForms].validate()
      this.loading = true
      const obj = deepCopy(this.form)
      obj.siteIds = obj.siteIds.join(',')
      try {
        await PutLabelAllGuest(obj, this.uuid)
        this.$emit('update')
        this.$message({
          type: 'success',
          message: '编辑外部人员成功'
        })
        this.dialogFormVisible = false
      } catch (e) {
        this.$message({
          type: 'error',
          message: e.errmsg
        })
      } finally {
        this.loading = false
      }
    },
  },
  mounted () {
    // console.log(this.editObj)
    if (this.isEdit) {
      // const form_ = deepCopy(this.editObj)
      this.form = {
        siteIds: this.editObj.siteIds.split(','),
        name: this.editObj.name,
        email: this.editObj.email,
        telephone: this.editObj.telephone,
        otherContactInfo: this.editObj.otherContactInfo,
      }
      this.uuid = this.editObj.id
    } else {
      this.form = {
        siteIds: [],
        name: null,
        email: null,
        telephone: null,
        otherContactInfo: null,
      }
      this.uuid = undefined
    }
  },
}
</script>
<style scoped lang="less">
.add-or-edit-without-persons-forms {
  ::v-deep(.el-form-item) {
    margin-bottom: 22px!important;
  }
  ::v-deep(.el-select) {
    width: 100%;
  }
}

</style>
